var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.70188 7.59668L0.408982 12.8896C0.0184575 13.2801 0.0184575 13.9133 0.408982 14.3038C0.799506 14.6943 1.43267 14.6943 1.8232 14.3038L7.8232 8.30379C8.21372 7.91326 8.21372 7.2801 7.8232 6.88957L1.8232 0.889572C1.43267 0.499048 0.799507 0.499048 0.408983 0.889571C0.0184586 1.2801 0.0184585 1.91326 0.408983 2.30379L5.70188 7.59668Z",
    fill: "#F9009E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.e0bf802375ed34652d910ec820555ff4.svg";
export { ForwardRef as ReactComponent };